var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn-toggle', {
    attrs: {
      "tile": "",
      "color": "secondary"
    },
    on: {
      "change": _vm.setQuery
    },
    model: {
      value: _vm.query.state,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "state", $$v);
      },
      expression: "query.state"
    }
  }, _vm._l(_vm.items, function (_ref) {
    var text = _ref.text,
      value = _ref.value;
    return _c('v-btn', _vm._b({
      key: text
    }, 'v-btn', {
      value: value
    }, false), [_vm._v(_vm._s(text))]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }